import { connect } from 'react-redux';

import { Entities, fetchByCompanyId, getEntities, patch, save } from 'src/common';
import { getOwnCompany } from 'src/selectors/bus-companies';
import CalendarSeasonAdministration from 'src/components/administration/calendar-season/calendar-season-administration';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        company: getOwnCompany(state),
        calendarSeason: getEntities(state, Entities.CALENDAR_SEASON, state.selectedCompany),
        calculations: getEntities(state, Entities.CALCULATION, state.selectedCompany),
    };
};

const CalendarSeasonAdministrationContainer = connect(mapStateToProps, { patch, fetchByCompanyId, save })(
    CalendarSeasonAdministration,
);

export default CalendarSeasonAdministrationContainer;
